import { useState } from "react";
import {
  Box,
  Card,
  Avatar,
  Typography,
  Divider,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  Stack,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import PhoneIcon from "@mui/icons-material/Phone";
import { grey } from "@mui/material/colors";
import ContactAgent from "../agents/AgentDetail/ContactAgent";
import { useNavigate } from "react-router-dom";

const blueLabelSx = {
  color: "alternate.main",
  fontSize: "1rem",
};
const contentSx = {
  fontSize: "1rem",
};
const truncateStyles = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  wordBreak: "break-word",
};
const cardStyle = {
  p: 2,
  borderRadius: 3,
  border: "1px solid",
  height: "19rem",
  mx: "auto",
  boxShadow: "none",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const AgentProfileCard = ({
  id,
  avatarSrc,
  name,
  status,
  rating,
  reviewCount,
  specialties = [],
  location,
  phone,
  email,
  featured = false,
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Card
        sx={{
          ...cardStyle,
          borderColor: featured ? "primary.main" : "border.lighter",
          gap: 2,
          "&:hover": {
            bgcolor: grey[50],
          },
        }}
        onClick={() => navigate(`/agents/${id}`)}
      >
        <Stack gap={1.2}>
          <Box sx={{ display: "flex", alignItems: "start" }}>
            <Avatar
              src={avatarSrc}
              alt={name}
              sx={{
                width: 45,
                height: 45,
                mr: 2,
                backgroundColor: "background.avatar",
              }}
            />
            <Box>
              <Typography
                variant="body"
                component="h2"
                sx={{
                  fontWeight: "bold",
                  textTransform: "capitalize",
                  WebkitLineClamp: 1,
                  ...truncateStyles,
                  fontSize: "18px",
                }}
              >
                {name}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", pt: 0.75 }}>
                <Typography variant="body2" color="text.secondary">
                  {status}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <StarIcon sx={{ color: "warning.main", mr: 0.5 }} />{" "}
            <Typography variant="body1" sx={{ fontWeight: "bold", mr: 0.5 }}>
              {rating}
            </Typography>
            <Typography variant="body2" color="text.alternate" sx={{ mr: 0.5 }}>
              Based on reviews
            </Typography>
            {/* <Typography
              href="#"
              color="button.link"
              sx={{ fontSize: "0.875rem" }}
            >
              {reviewCount} reviews
            </Typography> */}
          </Box>

          <Divider />

          <Box>
            <Typography sx={blueLabelSx}>Specialties</Typography>
            <Typography
              sx={{
                ...contentSx,
                ...truncateStyles,
                WebkitLineClamp: 1,
              }}
            >
              {specialties.length > 0 ? specialties?.join(", ") : "-"}
            </Typography>
          </Box>

          <Divider />

          <Box>
            <Typography sx={blueLabelSx}>Location</Typography>
            <Typography
              sx={{
                ...contentSx,
                WebkitLineClamp: 2,
              }}
            >
              {location ? location : "N/A"}
            </Typography>
          </Box>

          <Divider />
        </Stack>

        {/* Action Buttons */}
        <Box sx={{ display: "flex", gap: 1.5 }}>
          <Button
            variant="outlined"
            color="alternate"
            size="medium"
            fullWidth
            sx={{
              borderRadius: 8,
              textTransform: "none",
              color: "text.blue",
              fontSize: "1rem",
              borderColor: "alternate.main",
              height: "2.4rem",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setOpen(true);
            }}
          >
            Send a message
          </Button>

          <a onClick={(e) => e.stopPropagation()} href="tel:+18886165270">
            <IconButton
              variant="outlined"
              sx={{
                border: "1px solid",
                borderColor: "alternate.main",
                borderRadius: 2,
                height: "2.4rem",
                "&:hover": {
                  border: "1px solid rgba(25, 118, 210, 0.8)",
                  bgcolor: "action.hover",
                },
              }}
            >
              <PhoneIcon color="alternate" />
            </IconButton>
          </a>
        </Box>
      </Card>

      {open && (
        <Dialog
          fullWidth
          maxWidth="sm"
          open={open}
          onClose={() => setOpen(false)}
          onClick={(e) => e.stopPropagation()}
        >
          <DialogContent>
            <ContactAgent
              agent_id={id}
              agentName={name}
              onClose={() => setOpen(false)}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default AgentProfileCard;
